<template>
  <main>
    <div class="row">
      <div class="col-12">
        <div class="tile">
          <div class="form-inline">
            <b-form-input class="mr-1 mb-1" v-model="filterFormModel.keyword" v-on:keydown.enter="load"
                          :placeholder="$t('keyword')"></b-form-input>
            <button @click="load" class="btn btn-primary mr-1 mb-1">{{ $t('search') }}</button>
            <button @click="reset" class="btn btn-secondary mr-1 mb-1">Reset</button>
          </div>
        </div>
      </div>
      <div class="col-12">
        <div class="c-sorting" v-if="['owner', 'admin', 'tech'].includes($store.state.user.role)">
          <div class="row">
            <div class="col-lg-12 c-sorting__right">
              <div class="c-sorting__btn">
                <button @click="create" class="btn btn-sm btn-success">
                  <font-awesome-icon icon="plus"/>&nbsp;{{ $t('create') }}
                </button>
              </div>
            </div>
          </div>
        </div>
        <div class="c-paging clearfix">
          <div class="c-paging__count" v-if="itemCount">{{ $t('found', [itemCount]) }}</div>
          <div class="c-paging__right">
            <div class="c-paging__numbers">
              <b-pagination v-if="itemCount > filterFormModel.pageSize" class="pull-right" size="sm"
                            v-model="filterFormModel.page" :total-rows="itemCount"
                            :per-page="filterFormModel.pageSize" @input="load"></b-pagination>
            </div>
          </div>
        </div>
      </div>
      <div class="col-12">
        <b-alert show variant="info" class="small">{{ $t('znsGatewayNote') }}</b-alert>
      </div>
      <div class="col-12" v-if="items.length">
        <div class="c-smart-table tile">
          <div class="row c-smart-table__title">
            <div class="col-lg-5">{{ $t('gatewayName') }}</div>
            <div class="col-lg-3">{{ $t('status') }}</div>
            <div class="col-lg-2">{{ $t('time') }}</div>
            <div class="col-lg-2"></div>
          </div>
          <div class="row" v-for="item in items" :key="item._id">
            <div class="col-lg-5">
              <p><b>{{ item.name }}</b></p>
              <p v-if="item.desc"><span class="text-gray-999">{{ item.desc }}</span></p>
            </div>
            <div class="col-lg-3">
              <p>
                <span class="badge" :class="item.active ? 'badge-success' : 'badge-secondary'">
                  {{ item.active ? $t('activated') : $t('deactivated') }}
                </span>
                <span v-if="item.isDefault" class="badge badge-primary ml-1">{{ $t('defaultGateway') }}</span>
              </p>
            </div>
            <div class="col-lg-2">
              <p><b class="text-gray-999">{{ $t('createTime') }}: </b><span>{{ item.createTime | moment('DD/MM/YYYY HH:mm') }}</span></p>
              <p v-if="item.updateTime"><b class="text-gray-999">{{ $t('updateTime') }}: </b><span>{{ item.updateTime | moment('DD/MM/YYYY HH:mm') }}</span></p>
            </div>
            <div class="col-lg-2">
              <div class="c-smart-table__content">
                <div class="c-buttons clearfix is-2">
                  <div class="c-buttons__col" v-if="['owner', 'admin', 'tech'].includes($store.state.user.role)">
                    <button @click="update(item._id)" type="button" class="btn btn-sm btn-info mr-1">
                      <font-awesome-icon icon="edit"/>&nbsp;{{ $t('edit') }}
                    </button>
                    <button @click="del(item._id)" type="button" v-if="['owner', 'admin'].includes($store.state.user.role)"
                            class="btn btn-sm btn-danger mr-1">
                      <font-awesome-icon icon="trash"/>&nbsp;{{ $t('delete') }}
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="col-12 text-center text-danger" v-if="!items.length">
        <span v-if="filterFormModel.page === 1 && !filterFormModel.keyword">{{ $t('notFoundCreate') }}</span>
        <span v-if="filterFormModel.page > 1 || filterFormModel.keyword">{{ $t('notFoundSearch') }}</span>
      </div>
    </div>
    <b-modal v-model="showForm" :title="formTitle" @ok="save" no-close-on-backdrop no-enforce-focus>
      <form-input :label="$t('gatewayName')" :model="formModel" attribute="name" :errors="formErrors"></form-input>
      <form-input :label="$t('desc')" :model="formModel" attribute="desc" :errors="formErrors"></form-input>
      <form-checkbox :model="formModel" attribute="active" :chk-label="$t('activated')" :errors="formErrors"></form-checkbox>
      <form-checkbox :model="formModel" attribute="isDefault" :chk-label="$t('setDefaultGateway')" :errors="formErrors"></form-checkbox>
    </b-modal>
  </main>
</template>

<script>
import List from '../../mixins/List';
import CRUD from "../../mixins/CRUD";

export default {
  mixins: [List, CRUD],
  data: function () {
    return {
      service: '/zns-gateway',
      autoLoad: true,
      defaultFormModel: {
        name: null,
        desc: null,
        active: true,
        isDefault: false,
      }
    }
  },
  i18n: {
    messages: {
      en: {
        gatewayName: 'Provider name',
        defaultGateway: 'Default',
        setDefaultGateway: 'Set as default provider (OAs without a provider use this)',
        createTime: 'Create time',
        updateTime: 'Update time',
        znsGatewayNote: 'ZBS provider is only a label for attribution/reconciliation — the sending API is still 100% Zalo.',
      },
      vi: {
        gatewayName: 'Tên nhà cung cấp',
        defaultGateway: 'Mặc định',
        setDefaultGateway: 'Đặt làm nhà cung cấp mặc định (OA chưa gán sẽ ăn theo)',
        createTime: 'Tạo lúc',
        updateTime: 'Cập nhật lúc',
        znsGatewayNote: 'Nhà cung cấp ZBS chỉ là nhãn để đối soát/thống kê — API gửi tin vẫn 100% của Zalo.',
      }
    }
  },
  methods: {}
};
</script>
